/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_ToggleInputs */

const en_sidebar_toggle = /** @type {(inputs: Sidebar_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle sidebar`)
};

const es_sidebar_toggle = /** @type {(inputs: Sidebar_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar u ocultar barra lateral`)
};

/**
* | output |
* | --- |
* | "Toggle sidebar" |
*
* @param {Sidebar_ToggleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_toggle = /** @type {((inputs?: Sidebar_ToggleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_ToggleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_toggle(inputs)
	return es_sidebar_toggle(inputs)
});